<template>
  <div>
    <div id="asdStore" class="banner" :class="{ hidden: hidden }">
      <span>Would you like to view this in the app</span>
      <a target="_blank" rel="noreferrer" :href="`${linkPlatformUrl}`">
        <span class="item-logo"><img :src="linkPlatform" alt="logo_app"/></span
      ></a>
      <span
        ><font-awesome-icon class="item-close" @click="closeAds" icon="times"
      /></span>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    platform: null,
    linkPlatform: null,
    linkPlatformUrl: null,
    hidden: false,
    info: {
      androidStoreUrl: "",
      iosStoreUrl: ""
    }
  }),
  created() {
    this.platform = navigator.platform.toLowerCase();
    if (this.platform == "iphone") {
      this.linkPlatform = "/img/movie/istore.png";
    } else {
      this.linkPlatform = "/img/movie/gplay.png";
    }
    this.$Parse.Cloud.run("getAppInfo", this.params)
      .then(res => {
        this.info = res;
      })
      .catch(error => {
        console.log(error);
      });
  },
  watch: {
    info() {
      if (this.platform == "iphone") {
        this.linkPlatformUrl = this.info.iosStoreUrl;
      } else {
        this.linkPlatformUrl = this.info.androidStoreUrl;
      }
    }
  },
  methods: {
    closeAds() {
      this.hidden = true;
    }
  }
};
</script>

<style scoped>
.banner {
  width: 100%;
  background-color: black;
  position: absolute;
  left: 0;
  right: 0;
  top: 62px;
  margin: 0;
  padding: 5%;
  font-size: 0.7rem;
  display: grid;
  grid-template-columns: 1fr 120px minmax(50px, 15%);
  justify-content: space-around;
  align-items: center;
  visibility: hidden;
}
.item-logo > img {
  width: 100px;
  margin-left: 10px;
}
.item-close {
  font-size: 2em;
  cursor: pointer;
  align-self: center;
}
.hidden {
  visibility: hidden !important;
}

@media (max-width: 600px) {
  .banner {
    visibility: initial;
  }
}
</style>
